import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { getTenantSlugsFromHost } from 'services/stytchAuthService';
import { validateTenant } from 'services/b2c/consumerAuthService';
import Loader from 'wrapper/loader';

/**
 * Route-level wrapper that validates org/branch slugs from the hostname
 * BEFORE rendering any child route. Covers the welcome page, B2C login,
 * and B2B login so every public page on a tenant subdomain is gated.
 *
 * - null  = still checking (shows loading)
 * - true  = valid tenant, render children via <Outlet />
 * - false = invalid tenant, show error
 */
const TenantGate = () => {
  const [tenantValid, setTenantValid] = useState(null);
  const [tenantError, setTenantError] = useState('');

  useEffect(() => {
    const { clientSlug, branchSlug } = getTenantSlugsFromHost();

    if (!clientSlug) {
      // No slug in hostname (e.g., localhost) — skip validation
      setTenantValid(true);
      return;
    }

    let cancelled = false;
    validateTenant(clientSlug, branchSlug)
      .then((resp) => {
        if (cancelled) return;
        const data = resp?.data ?? {};
        if (data.valid) {
          setTenantValid(true);
        } else {
          setTenantValid(false);
          setTenantError('Invalid organization or branch. Please check your URL.');
        }
      })
      .catch((err) => {
        if (cancelled) return;
        const detail = err?.response?.data?.detail;
        setTenantValid(false);
        setTenantError(detail || 'Organization not found. Please check your URL.');
      });

    return () => { cancelled = true; };
  }, []);

  if (tenantValid === null) {
    return (
      <Loader
        variant="colorful"
        FullScreen={true}
        message="Verifying organization..."
      />
    );
  }

  if (tenantValid === false) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100vh', gap: '1rem' }}>
        <img src="/fundmoreai.png" alt="Fundmore" style={{ height: '48px' }} />
        <h1 style={{ fontSize: '1.5rem', fontWeight: 600, color: '#111827' }}>Invalid Portal URL</h1>
        <p style={{ color: '#6b7280', maxWidth: '400px', textAlign: 'center' }}>{tenantError}</p>
      </div>
    );
  }

  return <Outlet />;
};

export default TenantGate;
